import { TFunction } from "i18next";

// Doctor honorific for a gender code (1 = male, 2 = female), from i18n so it
// stays translatable. Empty for unknown/other genders.
export const doctorTitle = (gender: number | undefined, t: TFunction): string =>
  gender === 1
    ? t("common.doctorTitleMale")
    : gender === 2
    ? t("common.doctorTitleFemale")
    : "";
